const getStoredData = () => {
  try {
    return JSON.parse(localStorage.getItem('architect-user-preferences')) || {};
  } catch (e) {
    // Optionally clear the corrupted data
    localStorage.removeItem('architect-user-preferences');
    return {};
  }
};

export const getPreference = (key) => {
  let storedData = getStoredData();
  return storedData[key] || null;
};

export const setPreference = (key, value) => {
  let storedData = getStoredData();
  storedData[key] = value;
  localStorage.setItem(
    'architect-user-preferences',
    JSON.stringify(storedData)
  );
};

export const deletePreference = (key) => {
  let storedData = getStoredData();
  delete storedData[key];
  localStorage.setItem(
    'architect-user-preferences',
    JSON.stringify(storedData)
  );
};
